module.exports = "/_next/static/images/Pin-8424e4ae1123c4c679f46fe1b8fc46e2.png";